<template>
    <div class='qualityDetailBox'>
        <QualityDetail :form="form" :userType="userType"></QualityDetail>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import QualityDetail from '@/components/consultant/QualityDetail.vue'
export default {
    name: "qualityDetailBox",
    components: {
        Button,
        QualityDetail
    },
    data() {
        return {
            swiperIndex: 0,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            userType:1,
            id: this.$route.query.id,
            form: {}
            // form: {
            //     "id": 2,
            //     "studentId": 4,
            //     "type": 2,
            //     "name": "活动名称",
            //     "role": 2,
            //     "startDate": "2018-12-21",
            //     "endDate": "2020-12-19",
            //     "organizationalUnit": "组织单位",
            //     "chargeTeacher": "负责教师",
            //     "picUrl": ["\/data\/img\/20201230\/1609325836735Burner-1080.jpg", "\/data\/img\/20201230\/1609325836513Explosion_4k.jpg", "\/data\/img\/20201230\/1609325836557Explosion_1080.jpg", "\/data\/img\/20201230\/1609325836410Burner-4k.jpg", "\/data\/img\/20201230\/1609325836669Aurora-1080.jpg"],
            //     "createdAt": "2020-12-30 18:57:16",
            //     "updatedAt": "2020-12-30 18:57:16",
            //     "deletedAt": null,
            //     "typeName": "大学先修课",
            //     "roleName": "参与者"
            // }
        }
    },
    created() {
        if(this.id) {
            this.detailComplexQualityByStudent()
        }else {
            this.form  = JSON.parse(window.sessionStorage.getItem("formQuality"));
        }
    },
    methods: {
      // 获取综合素质详情
        detailComplexQualityByStudent(){
        let id = this.$route.query.id;
        this.$ajax.post(this.G_acapi + this.ports.student.student.studentMessage.quality.detailComplexQualityByStudent, {
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.form = res.data.data;
          }
        })
      },
    },
}
</script>
<style scoped lang="less">
.qualityDetailBox {

}
</style>